import AndroidInstall from "../../../../contents/docs/integrate/_snippets/install-android.mdx";
import AndroidSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-android.mdx";
import AndroidIdentify from "../../../../contents/docs/libraries/android/_snippets/identify.mdx";
import IdentifiedVsAnonymousIntro from "../../../../contents/docs/product-analytics/_snippets/identified-vs-anonymous-intro.mdx";
import HowToCaptureAnonymousEventsAndroid from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-anonymous-events-android.mdx";
import HowToCaptureIdentifiedEvents from "../../../../contents/docs/product-analytics/_snippets/how-to-capture-identified-events-android.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import AndroidFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-android.mdx";
import * as React from 'react';
export default {
  AndroidInstall,
  AndroidSendEvents,
  AndroidIdentify,
  IdentifiedVsAnonymousIntro,
  HowToCaptureAnonymousEventsAndroid,
  HowToCaptureIdentifiedEvents,
  FeatureFlagsLibsIntro,
  AndroidFeatureFlagsCode,
  React
};